import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import type { DrilldownFilter } from '../utils/drilldown';
import styles from './DrilldownBreadcrumb.module.css';

interface DrilldownBreadcrumbProps {
  filters: DrilldownFilter[];
  onRemove: (index: number) => void;
  onClearAll: () => void;
}

export default function DrilldownBreadcrumb({
  filters,
  onRemove,
  onClearAll,
}: DrilldownBreadcrumbProps) {
  if (filters.length === 0) return null;

  return (
    <div className={styles.bar}>
      <span className={styles.allLabel}>All</span>
      {filters.map((f, i) => (
        <span key={i} className={styles.crumb}>
          <FontAwesomeIcon icon={faChevronRight} className={styles.separator} />
          <span className={styles.crumbLabel}>{f.label}</span>
          <button
            className={styles.removeBtn}
            onClick={() => onRemove(i)}
            title={`Remove filter: ${f.label}`}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </span>
      ))}
      <button className={styles.clearBtn} onClick={onClearAll}>
        Clear all
      </button>
    </div>
  );
}
